/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_collection_items_empty_message27 = /** @type {(inputs: {}) => string} */ () => {
	return `This resource is empty.`
};

const fr_collection_items_empty_message27 = /** @type {(inputs: {}) => string} */ () => {
	return `Cette ressource est vide.`
};

const de_collection_items_empty_message27 = /** @type {(inputs: {}) => string} */ () => {
	return `Diese Ressource ist leer.`
};

const es_collection_items_empty_message27 = /** @type {(inputs: {}) => string} */ () => {
	return `Este recurso está vacío.`
};

const it_collection_items_empty_message27 = /** @type {(inputs: {}) => string} */ () => {
	return `Questa raccolta è vuota.`
};

const ar_collection_items_empty_message27 = /** @type {(inputs: {}) => string} */ () => {
	return `هذه المجموعة فارغة.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const collection_items_empty_message27 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.collection_items_empty_message27(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("collection_items_empty_message27", locale)
	if (locale === "en") return en_collection_items_empty_message27(inputs)
	if (locale === "fr") return fr_collection_items_empty_message27(inputs)
	if (locale === "de") return de_collection_items_empty_message27(inputs)
	if (locale === "es") return es_collection_items_empty_message27(inputs)
	if (locale === "it") return it_collection_items_empty_message27(inputs)
	return ar_collection_items_empty_message27(inputs)
};
export { collection_items_empty_message27 as "COLLECTION_ITEMS_EMPTY_MESSAGE" }